<script setup>
import { computed } from 'vue';
import { ORIENTATION } from './constants';

const props = defineProps({
  emoji: { type: String, required: true },
  orientation: { type: String, default: ORIENTATION.RIGHT },
});

// The pill straddles the bottom corner of the bubble, on the side opposite the timestamp.
const positionClass = computed(() =>
  props.orientation === ORIENTATION.LEFT
    ? 'ltr:right-2.5 rtl:left-2.5'
    : 'ltr:left-2.5 rtl:right-2.5'
);
</script>

<template>
  <span
    role="img"
    :aria-label="$t('CONVERSATION.CUSTOMER_REACTION', { emoji })"
    class="absolute -bottom-3 inline-flex items-center justify-center h-[22px] min-w-[26px] px-1.5 text-xs leading-none rounded-full select-none shadow-sm bg-n-background border border-n-slate-6"
    :class="positionClass"
  >
    {{ emoji }}
  </span>
</template>
